import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/StatusPage.css';

function TechnicianDenied() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div className="sp-page">
      <div className="sp-card">

        <div className="sp-icon sp-icon--denied">
          <svg viewBox="0 0 24 24" width="40" height="40" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" />
            <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </div>

        <h1 className="sp-title">Application Not Approved</h1>
        <p className="sp-greeting">Hi {user.full_name || 'there'},</p>
        <p className="sp-body">
          Unfortunately, your technician application did not pass our review process. This may be
          due to incomplete documentation, unverifiable credentials, or other factors assessed by
          our admin team.
        </p>

        <p className="sp-hint">
          If you believe this was a mistake or would like more information, please reach out to our
          support team. We are happy to clarify the decision and guide you on next steps, including
          re-applying with updated documents.
        </p>

        <div className="sp-actions">
          <button className="sp-btn" onClick={() => navigate('/contact')}>
            Contact Support
          </button>
          <button className="sp-btn sp-btn--ghost" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>

      </div>
    </div>
  );
}

export default TechnicianDenied;
